/**
 * Landing-specific tracking code management.
 * Injects Facebook Pixel and Google (GTM/GA4) scripts per-landing,
 * complementing the global tracking from TrackingScripts.
 */

const INJECTED_IDS = new Set();

export function injectLandingTracking(trackingCodes) {
  if (!trackingCodes || trackingCodes.length === 0) return;

  trackingCodes.forEach((tc) => {
    if (!tc.active || !tc.id) return;
    const scriptId = `landing-${tc.type}-${tc.id}`;
    if (INJECTED_IDS.has(scriptId) || document.getElementById(scriptId)) return;

    if (tc.type === "facebook_pixel") {
      injectFacebookPixel(tc.id, scriptId);
    } else if (tc.type === "google_gtm") {
      injectGTM(tc.id, scriptId);
    } else if (tc.type === "google_analytics") {
      injectGA4(tc.id, scriptId);
    }
    INJECTED_IDS.add(scriptId);
  });
}

function injectFacebookPixel(pixelId, scriptId) {
  // Only init if fbq already exists (from global pixel), otherwise create it
  if (window.fbq) {
    // Add this pixel as additional pixel
    window.fbq("init", pixelId);
    window.fbq("trackSingle", pixelId, "PageView");
  } else {
    const script = document.createElement("script");
    script.id = scriptId;
    script.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${pixelId}');fbq('track','PageView');`;
    document.head.appendChild(script);

    const noscript = document.createElement("noscript");
    noscript.id = `${scriptId}-ns`;
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1"/>`;
    document.body.appendChild(noscript);
  }
}

function injectGTM(gtmId, scriptId) {
  if (document.getElementById(scriptId)) return;
  const script = document.createElement("script");
  script.id = scriptId;
  script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtmId}');`;
  document.head.appendChild(script);
}

function injectGA4(ga4Id, scriptId) {
  if (document.getElementById(scriptId)) return;
  const gtagScript = document.createElement("script");
  gtagScript.id = scriptId;
  gtagScript.async = true;
  gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${ga4Id}`;
  document.head.appendChild(gtagScript);

  const configScript = document.createElement("script");
  configScript.id = `${scriptId}-config`;
  configScript.innerHTML = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${ga4Id}');`;
  document.head.appendChild(configScript);
}

export function cleanupLandingTracking() {
  INJECTED_IDS.forEach((scriptId) => {
    const el = document.getElementById(scriptId);
    if (el) el.remove();
    const ns = document.getElementById(`${scriptId}-ns`);
    if (ns) ns.remove();
    const cfg = document.getElementById(`${scriptId}-config`);
    if (cfg) cfg.remove();
  });
  INJECTED_IDS.clear();
}

export function trackLandingConversion(trackingCodes, leadData = {}) {
  if (!trackingCodes || trackingCodes.length === 0) return;

  trackingCodes.forEach((tc) => {
    if (!tc.active || !tc.id) return;

    if (tc.type === "facebook_pixel" && window.fbq) {
      window.fbq("trackSingle", tc.id, "Lead", {
        content_name: leadData.product_name || "preventivo",
        content_category: "landing_promo",
        landing_slug: leadData.landing_slug || "",
      });
    }

    if ((tc.type === "google_gtm" || tc.type === "google_analytics") && window.dataLayer) {
      window.dataLayer.push({
        event: "lead_form_submit",
        lead_source: "landing_promo",
        tracking_label: tc.label || tc.id,
        landing_slug: leadData.landing_slug || "",
        product_name: leadData.product_name || "",
      });
    }
  });
}
